import { ThemedHeader } from 'components/ThemedHeader';

export interface GenericPagePreviewProps {
  title: string;
  containerDataTestId: string;
  titleDataTestId: string;
  children: React.ReactNode;
  blockClasses?: string;
  id?: string;
}

export const GenericPagePreview = ({
  title,
  containerDataTestId,
  titleDataTestId,
  children,
  blockClasses,
  id = 'generic-page-preview',
}: GenericPagePreviewProps) => {
  return (
    <main className={blockClasses} data-testid={containerDataTestId} id={id}>
      <ThemedHeader cssClass="px-4 pb-4 pt-2_5 p-md-0 pt-md-1 mb-0 mb-md-4_5 mt-1">
        <span data-testid={titleDataTestId}>{title}</span>
      </ThemedHeader>

      {children}
    </main>
  );
};
